export function getPaymentMethods() {
    return [
        { value: 'cash', label:'Gotówka' },
        { value: 'transfer', label:'Przelew' },
        { value: 'card', label:'Karta' },
        { value: 'cod', label:'Za pobraniem' },
        { value: 'paypal', label:'PayPal' },
        { value: 'setoff', label:'Kompensata' }
    ];
}

export function getLabelForPaymentMethod(id) {
    return getPaymentMethods().find((x) => x.value === id)?.label;
}

export function getPaymentMethodsDeadlines() {
    return [
        { value: 0, label:'Dzisiaj' },
        { value: 1, label:'1 dzień' },
        { value: 3, label:'3 dni' },
        { value: 5, label:'5 dni' },
        { value: 7, label:'7 dni' },
        { value: 14, label:'14 dni' },
        { value: 21, label:'21 dni' },
        { value: 30, label:'30 dni' },
        { value: 45, label:'45 dni' },
        { value: 60, label:'60 dni' },
        { value: 75, label:'75 dni' },
        { value: 90, label:'90 dni' },
    ];
}

export function getLabelForPaymentMethodDeadlines(id) {
    return getPaymentMethodsDeadlines().find((x) => x.value === id)?.label;
}